import React from 'react';
import { DisabledEpicLinkParentLinkField } from '../../common/ui/fields/epic-link-parent-link-disabled/index.tsx';
import { FieldContainer } from '../../common/ui/fields/styled.tsx';
import { withFormField } from '../../common/ui/with-form-field/index.tsx';
import type { Props, EpicLinkFieldConfig, FieldValue } from './types.tsx';
import { transformDefaultEpicValue } from './utils.tsx';

export const EpicLinkField = (props: Props) => {
	const { width } = props;

	// We are disabling the Epic Link and Parent Link fields for taking input and instead displaying that the user should
	// use the Parent field to set the Parent of the issue as part of migrating to a single way of representing Jira's hierarchy.
	return (
		<FieldContainer width={width}>
			<DisabledEpicLinkParentLinkField />
		</FieldContainer>
	);
};

export default withFormField({
	transformDefaultValue: transformDefaultEpicValue,
	// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<EpicLinkFieldConfig, FieldValue>, any>'.
})<EpicLinkFieldConfig, FieldValue>(EpicLinkField);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { mutateEpicLinkField } from './utils';
